import { useState, useEffect } from "react";
import { useSimulateSwapQuery } from "../store/api/dexApiSlice";
import { isErrorResponse } from "../store/api/common";
import { REACT_APP_TON_ADDRESS } from "constant";

export interface SimulateRequestData {
  swapAction: "offer" | "ask";
  offerAddress?: string;
  askAddress?: string;
  fromUnits: string;
  toUnits: string;
  slippageTolerance: number;
}

export enum SWAP_TYPE  {
  TON_TO_JETTON_SWAP = 0,
  JETTON_TO_TON_SWAP = 1,
  JETTON_TO_JETTON_SWAP = 2
} 
export interface SimulateSwapState {
  error?: string;
  swapRate: number;
  minAskUnits: string;
  offerUnits: string;
  askUnits: string;
  tonFeeUnits: string;
  priceImpact: number;
  askAddress: string;
  offerAddress: string;
  swapType: number;
}

const simulateSwapStateInitialData: SimulateSwapState = {
  swapType: SWAP_TYPE.TON_TO_JETTON_SWAP,
  swapRate: 0,
  minAskUnits: "0",
  offerUnits: "0",
  askUnits: "0",
  tonFeeUnits: "0",
  priceImpact: 0,
  askAddress: "",
  offerAddress: ""
};

export const useSimulateSwap = (data: SimulateRequestData) => {
  const [simulateState, setSimulateState] = useState(
    simulateSwapStateInitialData
  );
  const { data: simulateData }:any = useSimulateSwapQuery(
    {
      swapAction: data.swapAction,
      offer_address: data.offerAddress ?? "",
      ask_address: data.askAddress ?? "",
      units: data.swapAction === "offer" ? data.fromUnits : data.toUnits,
      slippage_tolerance: data.slippageTolerance,
    },
    {
      skip:
        !data.askAddress ||
        !data.offerAddress,
      pollingInterval: 1000 * 5,
    }
  )

  useEffect(() => {
    if (!simulateData || simulateData?.status_code === 403) {
      return;
    }

    if (isErrorResponse(simulateData)) {
      setSimulateState((prev) => ({
        ...prev,
        error: simulateData.code.toString(),
      }));
    } else {
      let swaptype = 0;
      
      if(data.offerAddress === REACT_APP_TON_ADDRESS){
        swaptype = SWAP_TYPE.TON_TO_JETTON_SWAP
      } else if(data.askAddress === REACT_APP_TON_ADDRESS) {
        swaptype = SWAP_TYPE.JETTON_TO_TON_SWAP
      } else {
        swaptype = SWAP_TYPE.JETTON_TO_JETTON_SWAP
      }
      setSimulateState({
        swapType: swaptype,
        swapRate: simulateData.swap_rate,
        minAskUnits: simulateData.min_ask_units,
        offerUnits: simulateData.offer_units,
        askUnits: simulateData.ask_units,
        tonFeeUnits: String(simulateData.offer_units/1000),
        priceImpact: simulateData.price_impact,
        askAddress: simulateData.ask_address,
        offerAddress: simulateData.offer_address
      });
    }
  }, [simulateData]);

  return simulateState;
};
